import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap'
import { useLocation } from "react-router-dom";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export default function PaymentSuccess() {
	let query = new URLSearchParams(useLocation().search);

	const [summary, setSummary] = useState([]);
	const [isGetSummary, setIsGetSummary] = useState(false);
	const [modalShow, setModalShow] = useState(true);
	const swalAlert = withReactContent(Swal);

	useEffect(() => {
		if (isGetSummary === false) {
			swalAlert.fire({
				title: 'Please Wait...',
				allowOutsideClick: false
			});
			swalAlert.showLoading();

			axios.get('/api/order/' + query.get("paymentID"))
				.then((res) => {
					setSummary(res.data[0]['trans']);
					setIsGetSummary(true);

					swalAlert.close();
				})
		}
	}, []);

	return (
		<div id="product-hero">
			{isGetSummary
				?
				<section id="body">
					<PromptMessage show={modalShow} onHide={() => setModalShow(false)} />
					<div className="container">
						<div className="row">
							<div className="col-12">
								<div className="row shadow title position-relative">
									<h2 className="text-center m-5 text-white font-weight-bold">Payment Successful</h2>
								</div>
								<div className="row content">
									<div className="col-1"></div>
									<div className="col-10 shadow bg-white rounded p-5">
										<p className="mt-4">Hi, {summary.name}</p>
										<p>Thank you for your payment. Your transaction has been successful subject to Anti Money Laundering Act and Sanction screening.</p>
										<p>The insurance coverage will only take effect upon approval from {getInsurerFullName(summary.insurer)}.</p>
										<p>Confirmation of coverage will be issued by {summary.insurer} to your email address after the approval process</p>
										<p>Full premiums will be refunded by Howden if your application is not approved by {summary.insurer}.</p>
										<p>For any inquiries, please email us at <a href="mailto:insta.admin@my.howdengroup.com" target="_blank">insta.admin@my.howdengroup.com</a></p>

										<div className="card-deck mb-3 text-center">
											<div className="card mb-4 box-shadow">
												<div className="card-header" style={{ backgroundColor: "#c7ddea" }}>
													<h4 className="my-0" style={{ backgroundColor: "#c7ddea" }}>Purchase Summary</h4>
												</div>
												<div className="card-body p-0">
													<table className="table table-bordered table-condensed mb-0">
														<tbody>
															<tr>
																<td className="text-break w-50">Insurance Company <br /></td>
																<td className="text-break w-50 font-weight-bold">{summary.insurer}</td>
															</tr>
															<tr>
																<td className="text-break w-50">Transaction Reference No</td>
																<td className="text-break w-50 font-weight-bold">{summary.TransactionNo}</td>
															</tr>
															<tr>
																<td className="text-break w-50">Total Annual Premium</td>
																<td className="text-break w-50 font-weight-bold">{"RM " + summary.totalAnnualPremium.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
										<a href="/" className="btn btn-primary mt-3 mb-4" role="button">Back to Home</a>

										<div className="row my-4">
											<label className="col-12 col-form-label text-center font-weight-bold">You might also be interested in</label>
										</div>
										<div className="row mb-3 text-center justify-content-around">
											<div className="col-8 col-sm-4 mb-3 mb-sm-0">
												<a href={process.env.MIX_INSTAPOL_DOMAIN + "/covid-19"}>
													<img className="img-fluid" src="../images/covid-button.png" loading="lazy" width={200} />
												</a>
											</div>
											<div className="col-8 col-sm-4 mb-3 mb-sm-0">
												<a href={process.env.MIX_INSTAPOL_DOMAIN + "/motor"}>
													<img className="img-fluid" src="../images/motor-button.png" loading="lazy" width={200} />
												</a>
											</div>
											<div className="col-8 col-sm-4 mb-3 mb-sm-0">
												<a href="https://howden-wmotor.instapol.my/landing">
													<img className="img-fluid" src="../images/extended-motor-button.png" loading="lazy" width={200} />
												</a>
											</div>
										</div>
									</div>
									<div className="col-1"></div>
								</div>
							</div>
						</div>
					</div>
				</section>
				:
				<div className="text-center mt-5">
					<img src="https://instapol.my/images/loading.gif" />
					<br />
					Please wait
				</div>
			}
		</div>
	);
}

function PromptMessage(props) {
	return (
		<Modal {...props}
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Header>
				<Modal.Title className="container-fluid">
					<div className="row">
						<button type="button" className="close" onClick={props.onHide}><i className="fa fa-times-circle text-right"></i></button>
					</div>
					<div className="row">
						<div className="col-12 text-center text-primary">
							<label className="col-form-label">Get your <strong>FREE*</strong> PA, Covid 19 &amp;
								<br />Dengue cover up to RM10,000</label>
						</div>
					</div>
					<div className="row mt-3">
						<div className="col-12 text-center">
							<a className="btn btn-success badge-pill btn-lg px-5" href="https://instapol.my/">Click Here</a>
						</div>
					</div>



				</Modal.Title>
			</Modal.Header>
		</Modal>
	);
}

function getInsurerFullName(short_name) {
	let full_name = '';

	if (short_name === 'MPIG') {
		full_name = 'MPI Generali Insurans Berhad';
	} else if (short_name === 'AXA') {
		full_name = 'AXA Affin General Insurance Berhad';
	} else if (short_name === 'MSIG') {
		full_name = 'MSIG Insurance (Malaysia) Berhad';
	} else if (short_name === 'TUNE') {
		full_name = 'TUNE INSURANCE BERHAD';
	}

	return full_name;
}